import { render, staticRenderFns } from "./HomeCategoriesComponent.vue?vue&type=template&id=6ea60833&"
import script from "./HomeCategoriesComponent.vue?vue&type=script&lang=js&"
export * from "./HomeCategoriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports